import React, { useContext, ReactNode } from "react";
import { Navigate, useParams } from "react-router-dom";
import { AuthContext } from "../context/Context";

interface PublicRouteProps {
  children: ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { slug } = useParams<{ slug: string }>();

  const { isAuthenticated } = useContext(AuthContext);
  return !isAuthenticated ? (
    <>{children}</>
  ) : (
    <Navigate to={`/${slug}/vendors`} />
  );
};

export default PublicRoute;
